module.exports = __webpack_public_path__ + "media/images/suppliers/abebio-4251cc3ee867b2d23475fe14f5990cd4.png";